import { isNil } from '@pct/ts-typeguard';
import { translate } from '@jsverse/transloco';
export function getValidErrorKey(key: string): string {
  if (isNil(key)) {
    return 'UNKNOWN_ERROR';
  }

  if (translate(`API_ERRORS.${key}`) === `API_ERRORS.${key}`) {
    return 'UNKNOWN_ERROR';
  }

  return key;
}
